import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';

import theme from '../../../theme';

import { formatToken } from '../../../helpers/token-helper';
import s from './card-header.module.scss';
import BuyCrypto from '../../../blockchain/BuyCrypto';
import { useGetTheme } from '../../../hooks/useGetTheme';

const CardHeader = () => {
  const colors = useGetTheme();
  const totalStakeValueUsd = useSelector((state) => state.staking.totalStakedBalanceUsd);

  return (
    <>
      <div className={s.wrap} style={{ backgroundColor: colors.cardHeader }}>
        <div className={s.total} style={{ color: theme.palette.dark.text }}>
          <span className={s.key}>Total Staked Value:</span>
          <div className={s.val}>${formatToken(totalStakeValueUsd)}</div>
        </div>
        <div className={s.buyCyptoButton}>
          <BuyCrypto buttonText='Buy OM' dialogTitle='Buy OM' />
        </div>
      </div>
      <div className={s.separator} />
    </>
  );
};

CardHeader.propTypes = {
  migrateStatus: PropTypes.string.isRequired,
  omStakeBalance: PropTypes.string.isRequired,
  omV2StakeBalance: PropTypes.string.isRequired,
  rfuelStakeBalance: PropTypes.string.isRequired,
  uniStakeBalance: PropTypes.string.isRequired,
  uniV2StakeBalance: PropTypes.string.isRequired,
};

export default connect((state) => ({
  migrateStatus: state.OMstake.stake.migrateStatus,
  omStakeBalance: state.OMstake.stake.stakeBalance,
  omV2StakeBalance: state.OMV2stake.stake.stakeBalance,
  rfuelStakeBalance: state.RFUELstake.stake.stakeBalance,
  uniStakeBalance: state.UNIstake.stake.stakeBalance,
  uniV2StakeBalance: state.UNIV2stake.stake.stakeBalance,
}))(CardHeader);
